import { decToHex } from 'hex2dec';

export const buildGeoJson = (points, altitude, speed) => {
  const pointsJson = points.map(point => ({
    type: 'Feature',
    properties: {
      type: point.type,
      speed: speed,
      relativeAltitude: altitude
    },
    geometry: {
      type: 'Point',
      coordinates: [point.coordinates.lng, point.coordinates.lat]
    }
  }));

  return {
    type: 'FeatureCollection',
    features: pointsJson
  };
};

export const parseFlightRoutes = missions => {
  let hexMissions = {};
  Object.keys(missions).forEach(missionId => {
    const h3Hexes = missions[missionId].map(decimal => {
      return decToHex(decimal, { prefix: false });
    });
    hexMissions[missionId] = h3Hexes;
  });
  return hexMissions;
};
